import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from "vuetify/iconsets/fa";
import { aliases, mdi } from "vuetify/iconsets/mdi";
// make sure to also import the coresponding css
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "@fortawesome/fontawesome-free/css/all.css";
import { Buffer } from 'buffer';
import router from './router';
import { useAuthStore } from './store/authStore';

import { createPinia } from 'pinia';

const pinia = createPinia();

(window as any).Buffer = Buffer;
// Added Vutify in Project
const vuetify = createVuetify({
    components,
    directives,
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: {
        mdi,
        fa,
      },
    },
  })


const app = createApp(App);
app.use(vuetify);
app.use(pinia);
app.use(router);



// Wait for authentication before mounting the app
const initializeApp = async () => {
  const authStore = useAuthStore();

  await authStore.checkLoginStatus();

  if (!authStore.isLoggedIn) {
    const result = await authStore.login();
    // Full-page redirect leaves the app; iframe uses popup and must succeed to mount
    if (result === 'redirect') {
      return;
    }
    if (!authStore.isLoggedIn) {
      console.error('Authentication required: allow popups for this site when embedded in Salesforce.');
      return;
    }
  }

  app.mount('#app');
};

initializeApp();